
import { Component } from 'vue-property-decorator'
import BaseLayout from '@/shared/components/BaseLayout.vue'
import { Action, Getter } from 'vuex-class'
import SettingsMapping from '@/api/models/SettingsMapping'
import StorageMixin from '@/shared/mixins/StorageMixin.vue'
import CostMappingDto from '@/api/dto/CostMappingDto'

@Component({
    components: {
        BaseLayout
    },
    mixins: [StorageMixin]
})

export default class Costs extends BaseLayout {
    private readonly STATE = {
        DEFAULT: 'default',
        LOADING: 'loading'
    }

    @Getter('costs')
    costs!: Array<SettingsMapping>

    @Action('loadCostMappings')
    loadCostMappings!: () => Promise<void>

    @Action('saveCostMappings')
    saveCostMappings!: (mapping: CostMappingDto) => Promise<void>

    private loadAnimate = this.STATE.DEFAULT

    async created (): Promise<void> {
        await this.handleCallback(async () => {
            await this.loadCostMappings()
        })
    }

    async save (): Promise <void> {
        this.loadAnimate = this.STATE.LOADING
        const dto: CostMappingDto = this.clearDtoMapping(this.costs)
        await (this.$refs.baseLayout as BaseLayout).handleWithAlerts(async () => {
            await this.saveCostMappings(dto)
        }, this.$t('commissionMapping.success'))

        this.loadAnimate = this.STATE.DEFAULT
    }

    clearDtoMapping (costs: Array<SettingsMapping>): CostMappingDto {
        const clearedMapping: Array<SettingsMapping> = costs.filter(x => x.codeSystem)
        return ({
            costs: clearedMapping
        } as CostMappingDto)
    }
}
